<template lang="pug">
div
  app-divider(label="Imóvel")
  el-row.pad5
    el-col(:span="12")
      p
        span.label Número do recibo:
        span.labelNumeroRecibo  &nbsp {{filterNull(imovel.numeroReciboCar)}}
    el-col(:span="12", v-if="inputsExtraCadastro.imovel.nomeImovelPropriedade")
      p
        span.label Nome do imóvel/Propriedade:
        span &nbsp {{imovel.nomeImovelPropriedade}}
    el-col(:span="12")
      p
        span.label Tempo de ocupação:
        span &nbsp {{filterNull(imovel.tempoOcupacao)}} ano(s)
    el-col(:span="12")
      p
        span.label Há ocupantes anteriores:
        span &nbsp {{hasOcupantesAnteriores}}
    el-col(:span="12")
      p
        span.label {{`Possui outros imóveis no ${ESTADO}:`}}
        span &nbsp {{hasOutrosImoveis}}
    el-col(:span="12")
      p
        span.label Há conflitos no imóvel:
        span &nbsp {{hasConflitos}}
    el-col(:span="12")
      p(v-if="imovel.conflitos")
        span.label Nº do processo judicial:
        span &nbsp {{filterNull(imovel.numeroProcessoJudicial)}}
  el-row.pad5(v-if="inputsExtraCadastro.imovel.escrituraDocumentoRegistro")
    app-resumo-documentos.margin-top(:documentos="imovel.documentos" codigoCadastro="imovel", :idCadastro="idCadastro")
</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppResumoDocumentos from '@/components/resumo/AppResumoDocumentos'
import { mapState } from 'vuex'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppResumoDocumentos
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    idCadastro: {
      type: Number
    }
  },
  data () {
    return {
      inputsExtraCadastro
    }
  },
  computed: {
    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    }),
    hasOcupantesAnteriores () {
      if (this.imovel.ocupantesAnteriores !== null) {
        return this.imovel.ocupantesAnteriores ? 'Sim' : 'Não'
      }
      return '-'
    },
    hasOutrosImoveis () {
      if (this.imovel.possuiImovel !== null) {
        return this.imovel.possuiImovel ? 'Sim' : 'Não'
      }
      return '-'
    },
    hasConflitos () {
      if (this.imovel.conflitos !== null) {
        return this.imovel.conflitos ? 'Sim' : 'Não'
      }
      return '-'
    }
  },
  methods: {
    filterNull (atributo) {
      return (atributo !== null && atributo !== '') ? atributo : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 460px;
  }

  .labelNumeroRecibo {
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/permuta/components/ResumoImovel.vue